import Layout from '@/views/Layout/Index.vue'
import { RouteRecordRaw } from 'vue-router'

export default <RouteRecordRaw>{
  path: '/Weimob',
  component: Layout,
  redirect: '/Home',
  name: 'Weimob',
  meta: { title: '微盟', icon: 'lock' },
  children: [
    {
      path: '/Weimob/Customer',
      component: () => import(/* webpackChunkName: "NotifyAssistant" */ '@/views/Weimob/Customer/Index.vue'),
      meta: { title: '会员管理', icon: 'el-icon-menu', roles: [] }
    },
    {
      path: '/Weimob/Rank',
      component: () => import(/* webpackChunkName: "NotifyAssistant" */ '@/views/Weimob/Coupon/Index.vue'),
      meta: { title: '卡券管理', icon: 'el-icon-user', roles: [] }
    }
  ]
}